// Supported UI locales. Mirrors anyainow's lib/i18n/locales.ts (same list +
// labels, so a visitor's choice reads the same across the *ainow family) but
// adapted for a client-only Vite SPA: localStorage instead of a cookie, and
// no server-side Accept-Language resolution (there's no per-request render
// to do it in — see i18n/README.md).
//
// Only `en` has a real catalog today (see messages/en.json) — the rest are
// listed so the switcher UI and detection logic are ready, but currently
// resolve to the English dictionary until real translations are added.
export const SUPPORTED_LOCALES = [
  "en",
  "es",
  "fr",
  "de",
  "it",
  "nl",
  "pt",
  "ja",
  "zh-CN",
];

export const DEFAULT_LOCALE = "en";

export const LOCALE_STORAGE_KEY = "freeainow:locale";

// Native-language labels for the language switcher.
export const LOCALE_LABELS = {
  en: "English",
  es: "Español",
  fr: "Français",
  de: "Deutsch",
  it: "Italiano",
  nl: "Nederlands",
  pt: "Português",
  ja: "日本語",
  "zh-CN": "中文",
};

export function isLocale(value) {
  return SUPPORTED_LOCALES.includes(value);
}

// Pick the best supported locale from navigator.language / navigator.languages
// (the SPA equivalent of anyainow's matchAcceptLanguage, which reads the
// Accept-Language header server-side — not available here).
export function matchBrowserLocale(languages) {
  for (const raw of languages ?? []) {
    const lower = raw.toLowerCase();
    const exact = SUPPORTED_LOCALES.find((l) => l.toLowerCase() === lower);
    if (exact) return exact;
    const primary = lower.split("-")[0];
    if (primary === "zh") return "zh-CN";
    const bySubtag = SUPPORTED_LOCALES.find((l) => l.toLowerCase() === primary);
    if (bySubtag) return bySubtag;
  }
  return DEFAULT_LOCALE;
}

export function readStoredLocale() {
  try {
    const v = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (v && isLocale(v)) return v;
  } catch {
    /* ignore unavailable storage */
  }
  return null;
}
